import React from 'react'
import { useHistory } from 'react-router-dom';

// icons
import { FiMonitor } from "react-icons/fi";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MdOutlineBorderColor } from "react-icons/md";


// react bootrap
import { Form } from 'react-bootstrap';

export default function CustomerScreen() {
    const history = useHistory()

    const fakeData = [
        {
            id: 1,
            title: 'xxxxxxxxxx',
            amount: '1',
            price: '000.000'
        },
        {
            id: 2,
            title: 'xxxxxxxxxx',
            amount: '1',
            price: '000.000'
        },
        {
            id: 3,
            title: 'xxxxxxxxxx',
            amount: '1',
            price: '000.000'
        },
        {
            id: 4,
            title: 'xxxxxxxxxx',
            amount: '1',
            price: '000.000'
        },
        {
            id: 5,
            title: 'xxxxxxxxxx',
            amount: '1',
            price: '000.000'
        }

    ]
    return (
        <div className='customerscreen-main'>
            <div className='customerscreen-title'>
                <span style={{ fontSize: '24px', color: '#6B7280' }}>
                    <ArrowBackIcon sx={{ fontSize: "30px", cursor: "pointer" }} onClick={() => history.goBack()} />
                    &emsp;
                    ຈັດການໜ້າຈໍລູກຄ້າ
                </span>
            </div>
            <div className='customerscreen-content'>
                <div className='customerscreen-left'>
                    <div className='customerscreen-left-content'>
                        <div style={{
                            height: "50px",
                            display: 'flex',
                            alignItems: "center",
                            paddingLeft: '20px',
                            justifyContent: 'flex-start',
                            border: "1px solid #F4AAB9",
                            borderRadius: "8px",
                            boxShadow: '1px 2px 1px #F4AAB9',
                        }}>
                            <span><FiMonitor /></span>
                            <span style={{ marginLeft: "10px" }}>ສະເເດງຈໍລູກຄ້າ</span>
                            <span style={{ marginLeft: "10px" }}>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch"
                                // label="Check this switch"
                                />
                            </span>
                        </div>
                        <div style={{
                            height: "50px",
                            paddingLeft: '20px',
                            display: 'flex',
                            marginTop: '30px',
                            alignItems: "center",
                            justifyContent: 'flex-start',
                            border: "1px solid #F4AAB9",
                            borderRadius: "8px",
                            boxShadow: '1px 2px 1px #F4AAB9',
                        }}>
                            <span><FiMonitor /></span>
                            <span style={{ marginLeft: "10px" }}>ສະເເດງຮູບໂຄສະນາ</span>
                            <span style={{ marginLeft: "10px" }}>
                                <Form.Check // prettier-ignore
                                    type="switch"
                                    id="custom-switch"
                                // label="Check this switch"
                                />
                            </span>
                        </div>
                    </div>
                </div>
                <div className='customerscreen-right'>
                    <div className='customerscreen-right-title'>ຮູບເເບບຕົວຢ່າງ</div>
                    <div className='customerscreen-right-content'>
                        <div className='customerscreen-right-lsit'>
                            <div style={{ textAlign: 'center', marginTop: "20px", fontSize: '20px', paddingBottom: "20px" }}>ລາຍການ</div>
                            <div style={{ display: 'grid', gridTemplateColumns: "auto auto auto auto" }}>
                                <div>ລຳດັບ</div>
                                <div>ຊື່ສິນຄ້າ</div>
                                <div>ຈຳນວນ</div>
                                <div>ລາຄາ</div>
                                {fakeData?.map((e, index) => (
                                    <>
                                        <div>{index + 1}</div>
                                        <div>{e?.title}</div>
                                        <div>{e?.amount}</div>
                                        <div>{e?.price}</div>
                                    </>
                                ))
                                }
                            </div>
                            <div style={{ marginTop: "50px" }}>ຍອດລວມ</div>
                            <div style={{ display: 'flex', justifyContent: "flex-end" }}>000.00 ກີບ</div>
                            <div style={{ display: 'flex', justifyContent: "flex-end" }}>000.00 ບາດ</div>
                            <div style={{ display: 'flex', justifyContent: "flex-end" }}>000.00 ໂດລາ</div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                background: "black",
                                color: "white",
                                height: "40px",
                                alignItems: "center",
                                padding: "20px",
                                fontSize: "20px",
                                marginTop: '20px'
                            }}>
                                <span>ຈຳນວນເງີນທີ່ຕອ້ງຈ່າຍ</span>
                                <span>000.00</span>
                            </div>
                        </div>
                        <div className='customerscreen-right-banner'>
                            <div className='customerscreen-rgiht-image'>
                                <span>Banner</span>
                            </div>
                            <div className='customerscreen-right-exchangeRate'>
                                <div style={{ textAlign: 'center',marginTop:"20px" }}>ອັດຕາເເລກປ່ຽນ</div>
                                <div style={{ marginTop: '10px',display:'flex',justifyContent:'space-around' }}>
                                    <span>THB : 500</span>
                                    <span>USD : 17.500</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
